/**
 * @license
 * @copyright Copyright Motili Inc., 2021 All Rights Reserved
 */

import { ReactElement } from 'react';
import { Paragraph, TextLink } from '@motili/ui';
import { styled } from 'styled-components';
import packageJson from '../../package.json';

export default function Footer(): ReactElement {
    const currentYear = new Date().getFullYear();
    return (
        <StyledFooter>
            <Paragraph>
                Need assistance? Call{' '}
                <TextLink href='tel:18002952388' text='1-800-295-2388' /> or
                email{' '}
                <TextLink
                    href='mailto:support@motili.com'
                    text='support@motili.com'
                />
                <StyledCopyrightAndVersion>
                    © Motili Inc 2017-{currentYear}&emsp;v
                    {packageJson.version}
                </StyledCopyrightAndVersion>
            </Paragraph>
        </StyledFooter>
    );
}

const StyledFooter = styled.footer`
    width: 680px;
    margin-top: 5px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 14px;
    @media (max-width: 500px) {
        display: flex;
        flex-direction: column;
        width: 100%;
        padding: 3%;
        text-align: center;
    }
`;

const StyledCopyrightAndVersion = styled.span`
    font-size: 11px;
    margin-left: 10px;
    @media (max-width: 500px) {
        display: flex;
        justify-content: center;
        width: 90%;
    }
`;
